import React, { useEffect, useState } from 'react';

const EVENT_START = new Date('2026-11-20T17:00:00-08:00').getTime();
const EVENT_END = new Date('2026-11-20T20:00:00-08:00').getTime();

const parts = (ms) => ({
  Days: Math.floor(ms / 86400000),
  Hours: Math.floor(ms / 3600000) % 24,
  Mins: Math.floor(ms / 60000) % 60,
  Secs: Math.floor(ms / 1000) % 60,
});

export const ThunderCountdown = () => {
  const [now, setNow] = useState(Date.now());
  useEffect(() => {
    const t = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(t);
  }, []);

  if (now >= EVENT_START) {
    return (
      <p className="text-center text-yellow-400 font-bold uppercase tracking-widest" data-testid="thunder-countdown-status">
        {now < EVENT_END ? 'Happening now!' : 'Thank you for joining us!'}
      </p>
    );
  }

  return (
    <div data-testid="thunder-countdown">
      <p className="text-center text-gray-400 text-xs uppercase tracking-[0.25em] mb-3">Showtime in</p>
      <div className="grid grid-cols-4 gap-2 sm:gap-3">
        {Object.entries(parts(EVENT_START - now)).map(([label, v]) => (
          <div key={label} className="rounded-xl bg-black/60 border border-yellow-500/30 py-3 text-center" data-testid={`thunder-countdown-${label.toLowerCase()}`}>
            <p className="text-3xl sm:text-4xl font-bold heading-oswald text-yellow-400 tabular-nums [text-shadow:0_0_14px_rgba(255,215,0,0.6)]">
              {String(v).padStart(2, '0')}
            </p>
            <p className="text-[10px] sm:text-xs text-gray-400 uppercase tracking-widest mt-1">{label}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
